import { render, staticRenderFns } from "./Trello.vue?vue&type=template&id=f8459786&"
import script from "./Trello.vue?vue&type=script&lang=js&"
export * from "./Trello.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports